"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("./Text"));
var _styles = require("../shared/styles");
var _flexComponents = require("./flex-components");
var _jsxRuntime = require("react/jsx-runtime");
var NavigationItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "NavigationItem__NavigationItemWrapper",
  componentId: "sc-bu6mr9-0"
})(["display:flex;align-items:center;box-sizing:border-box;cursor:pointer;", " :hover{text-shadow:0px 0px 1px ", ";}"], function (_ref) {
  var active = _ref.active;
  return active && "text-shadow: 0px 0px 1px ".concat(_styles.colors.text.brand, ";");
}, _styles.colors.text.brand);
var IndicatorBar = _styledComponents.default.div.withConfig({
  displayName: "NavigationItem__IndicatorBar",
  componentId: "sc-bu6mr9-1"
})(["display:flex;height:3px;margin-top:", ";background:", ";border-radius:2px;visibility:", ";"], _styles.spacing.m, _styles.colors.background.brand, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'visible' : 'hidden';
});
var NavigationItem = function NavigationItem(_ref3) {
  var children = _ref3.children,
    onClick = _ref3.onClick,
    active = _ref3.active;
  var _ref4 = (0, _react.useState)(),
    _ref5 = _slicedToArray(_ref4, 2),
    hover = _ref5[0],
    setHover = _ref5[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(NavigationItemWrapper, {
    active: active,
    onClick: onClick,
    title: children,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexColumn, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        color: active || hover ? 'brand' : 'primary',
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(IndicatorBar, {
        visible: active || hover
      })]
    })
  });
};
NavigationItem.defaultProps = {};
var _default = exports.default = NavigationItem;